import React from "react";
import { Facebook, Instagram, Linkedin } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-black text-white py-16">
      <div className="max-w-6xl mx-auto px-4 grid gap-12 md:grid-cols-2">
        {/* LOGO COMPLETO */}
        <div className="flex flex-col">
          <img
            src="/landing/logos/logo-metaverso.png"
            alt="Metaverso de la Construcción by Sinestesia"
            className="w-52 sm:w-64 md:w-72"
          />
        </div>

        {/* DIRECCIÓN + REDES */}
        <div className="flex flex-col gap-6 items-start md:items-end">
          <p className="text-lg leading-relaxed text-left md:text-right">
            Almirante Riveros 085, Providencia.
            <br />
            Santiago, Chile.
          </p>

          <div className="flex gap-4">
            <a
              href="http://www.instagram.com/sinestesia.cc"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="p-3 rounded-full transition-transform duration-200 hover:-translate-y-1 hover:scale-105"
            >
              <Instagram className="w-8 h-8" strokeWidth={1.25} />
            </a>

            <a
              href="https://www.facebook.com/sinestesia.cc"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="p-3 rounded-full transition-transform duration-200 hover:-translate-y-1 hover:scale-105"
            >
              <Facebook className="w-8 h-8" strokeWidth={1.25} />
            </a>

            <a
              href="https://www.linkedin.com/company/sinestesia-cc/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="p-3 rounded-full transition-transform duration-200 hover:-translate-y-1 hover:scale-105"
            >
              <Linkedin className="w-8 h-8" strokeWidth={1.25} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
